import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Button,message} from 'antd';
import {dbFields}  from '../../model/user/column';
import { route } from "../../routes/routes";
import { ResetPasswd } from "../../model/user/requests";
import storage from '../../utils/storage';
import { configs } from '../../config/config';


export const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 10,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

class PasswdReset extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {
                type: null,
                name:null
            }
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    handlerSubmit = (e) => {
        let passwd = this.formRef.current.getFieldValue(dbFields.passwd.key);
        let repasswd = this.formRef.current.getFieldValue(dbFields.repasswd.key);
        let id = parseInt(this.props.match.params.id);
        if(passwd !== repasswd){
            message.error("Please confirm the password")
            return false
        }
        if(passwd.length < 10) {
            message.error("password is too short ,please make sure larger than 10 length")
            return 
        }


        ResetPasswd({passwd:passwd,repasswd:repasswd,id:id}).then(res=>{
           if(res.data.code === 200){
               message.success("reset password sucess")
               storage.clear()
               this.props.history.push(route.default.login)
           }else{
               message.error(res.data.msg)
           }
        }).catch(err=>{
            message.error(err)
        })

    }

    render() {
        return (
            <>

                <BreadcrumbCustomer first='User' second='Reset' />
                <Form
                     {...layout}
                    ref={this.formRef}
                    onFinish={this.handlerSubmit}
                    initialValues={{
                        type:1
                    }}
                >

                    <Form.Item label={dbFields.passwd.title} name={dbFields.passwd.key}
                       rules={[
                        {
                            required: true,
                        },
                      ]}
                    >
                        <Input.Password  />
                    </Form.Item>

                    <Form.Item label={dbFields.repasswd.title} name={dbFields.repasswd.key}
                       rules={[
                        {
                            required: true,
                        },
                      ]}
                    >
                        <Input.Password  />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary"  style={{background: "#851dd6",color:"white" }} htmlType="submit" >Create</Button>
                    </Form.Item>
                </Form>  
            </>
        );
    }
}

export default PasswdReset;